import * as React from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Container, Header } from '../../'
import classes from './Home.module.css'
import { appStore } from '../../../index'
import { Pages } from '../../../Stores/AppStore'
import { LNG } from '../../../Services/LanguageService';

export const Home = observer(() => {
  const _onPrevClick = () => {
    appStore.setPage(Pages.PreviousAssignment)
  }
  const _onStartClick = () => {
    appStore.setPage(Pages.ScanJob)
    return false
  }

  return (
    <>
      <Header/>
      <Container actions={<Button label={LNG.Text('scannerApp.5')} onClick={_onPrevClick}/>}>
        <button className={classes.scan} onClick={_onStartClick}>
          <span className={classes.text}>{LNG.Text('scannerApp.6')}</span>
        </button>
      </Container>
    </>
  )
})
